import { Input } from "@/components/ui/input";
import { useLoad } from "@/lib/hooks";
import { Field, NativeSelect } from "@/components/common";

export function PlannedWasteFields({ form, setForm, quantity }) {
  const [inv] = useLoad("/inventory/overview");
  const items = inv?.items || [];
  const pct = form.planned_waste_pct;
  const bad = pct !== "" && (Number(pct) < 0 || Number(pct) > 100);
  const qty = Number(quantity || 0);
  const units = Math.round(qty * Number(pct || 0)) / 100;
  return (
    <>
      <Field label="Planned waste material (optional)"><NativeSelect testId="job-material-select" value={form.planned_waste_material_id || ""} onChange={(v) => setForm({ ...form, planned_waste_material_id: v })}
        options={[{ value: "", label: "None" }, ...items.map((i) => ({ value: i.id, label: `${i.code} · ${i.name}` }))]} /></Field>
      <Field label="Planned waste (%)">
        <Input type="number" min="0" max="100" step="any" placeholder="0" data-testid="job-planned-waste-pct-input" aria-invalid={bad} value={pct} onChange={(e) => setForm({ ...form, planned_waste_pct: e.target.value })} />
        {bad ? <p className="mt-1 text-xs text-rose-600" data-testid="job-planned-waste-error">Planned waste must be between 0 and 100%.</p>
          : <p className="mt-1 text-xs text-slate-500" data-testid="job-planned-waste-units">{Number(pct || 0)}% of {qty.toLocaleString()} = {units.toLocaleString()} units</p>}
      </Field>
    </>
  );
}

export const wasteValid = (f) => f.planned_waste_pct === "" || (Number(f.planned_waste_pct) >= 0 && Number(f.planned_waste_pct) <= 100);
export const wastePayload = (f) => ({ planned_waste_pct: f.planned_waste_pct === "" ? null : Number(f.planned_waste_pct), planned_waste_material_id: f.planned_waste_material_id || null });
